import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { Alert } from 'shared/ui'
import { type IAlertProps } from 'shared/ui/Alert/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { RcsPath } from 'pages/settings/pages/rcs/route/rcsPath'

export const RcsEmptyFallbackInboxAlert = observer(
  ({ alertProps }: { alertProps?: Partial<IAlertProps> }) => {
    const {
      usersStore: { hasRcsAccess },
      rcsStore: { hasFallbackInboxId, loading },
      inboxesStore: { hasRcsInbox },
    } = useEntitiesContext()

    if (!hasRcsInbox || hasFallbackInboxId || loading) return null

    let description = 'Some devices don’t support RCS. '

    description += hasRcsAccess
      ? 'Add a fallback inbox to ensure your messages get delivered.'
      : 'Ask an admin to configure a fallback inbox to ensure delivery.'

    const goToRcs = () => {
      uiStore.changeRoute({
        path: RcsPath.root,
      })
    }

    return (
      <Alert
        {...alertProps}
        item={{
          type: 'warning',
          desc: description,
        }}
        actions={
          hasRcsAccess
            ? [
                {
                  variant: 'button',
                  type: 'primary',
                  text: 'Configure fallback inbox',
                  onClick: goToRcs,
                },
              ]
            : undefined
        }
      />
    )
  }
)
